import React, { useState } from 'react';
import '../styles/Inventory.css';

const Inventory = () => {
  const [activeTab, setActiveTab] = useState('Stock Overview');

  const tabs = [
    'Stock Overview', 'Stock In', 'Stock Out', 'Stock Transfer', 
    'Stock Adjustment', 'Low Stock', 'Out of Stock', 'Stock Movement', 'Warehouses'
  ];

  const stats = [
    { id: 1, title: 'Total Stock Value', value: '₹8,57,345', subtext: 'vs last month', badge: '↑ 12.5%', badgeColor: 'green', iconBg: '#e0e7ff', iconColor: '#4f46e5', icon: <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path> },
    { id: 2, title: 'Total Stock Items', value: '346', subtext: 'All items in stock', iconBg: '#dcfce7', iconColor: '#16a34a', icon: <path d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"></path> },
    { id: 3, title: 'Low Stock Items', value: '23', subtext: 'Require attention', iconBg: '#fef3c7', iconColor: '#d97706', icon: <path d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path> },
    { id: 4, title: 'Out of Stock Items', value: '7', subtext: 'Need to restock', iconBg: '#fee2e2', iconColor: '#dc2626', icon: <path d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"></path> },
    { id: 5, title: 'Incoming Stock', value: '18', subtext: 'In next 7 days', iconBg: '#f3e8ff', iconColor: '#9333ea', icon: <path d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"></path> },
    { id: 6, title: 'Stock Out (Today)', value: '56', subtext: 'Items sold/moved', iconBg: '#e0f2fe', iconColor: '#0284c7', icon: <path d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"></path> }
  ];

  const tableData = [
    { id: 1, name: 'Adenium Plant', subName: '(Desert Rose)', sku: 'PLT001', barcode: '8901234567890', category: 'Plants', warehouse: 'Main Store', stock: 120, minStock: 20, value: '₹24,000', status: 'In Stock', date: '20 May 2025', time: '10:30 AM', img: '🪴' },
    { id: 2, name: 'Cactus Plant', subName: '(Small)', sku: 'PLT002', barcode: '8901234567891', category: 'Plants', warehouse: 'Main Store', stock: 35, minStock: 50, value: '₹3,500', status: 'Low Stock', date: '20 May 2025', time: '09:15 AM', img: '🌵' },
    { id: 3, name: 'Coco Peat 5kg', subName: '', sku: 'S001', barcode: '8901234567892', category: 'Soil & Media', warehouse: 'Main Store', stock: 0, minStock: 30, value: '₹0', status: 'Out of Stock', date: '19 May 2025', time: '06:45 PM', img: '🟫' },
    { id: 4, name: 'Organic Fertilizer 1kg', subName: '', sku: 'FRT001', barcode: '8901234567893', category: 'Fertilizers', warehouse: 'Main Store', stock: 60, minStock: 20, value: '₹5,400', status: 'In Stock', date: '20 May 2025', time: '11:20 AM', img: '🧪' },
    { id: 5, name: 'Plastic Pot 10 inch', subName: '', sku: 'POT001', barcode: '8901234567894', category: 'Pots', warehouse: 'Main Store', stock: 15, minStock: 25, value: '₹1,050', status: 'Low Stock', date: '20 May 2025', time: '08:50 AM', img: '🪣' },
    { id: 6, name: 'Plant Spray 500ml', subName: '', sku: 'SPR001', barcode: '8901234567895', category: 'Accessories', warehouse: 'Main Store', stock: 80, minStock: 15, value: '₹6,400', status: 'In Stock', date: '20 May 2025', time: '09:05 AM', img: '💦' },
    { id: 7, name: 'Hanging Planter', subName: '', sku: 'POT002', barcode: '8901234567896', category: 'Pots', warehouse: 'Main Store', stock: 0, minStock: 10, value: '₹0', status: 'Out of Stock', date: '18 May 2025', time: '04:30 PM', img: '🪴' },
  ];

  const getStatusClass = (status) => {
    if (status === 'In Stock') return 'status-in-stock';
    if (status === 'Low Stock') return 'status-low-stock';
    return 'status-out-stock';
  };

  return (
    <div className="inventory-wrapper">
      
      {/* Top Stats Cards */}
      <div className="inv-stats-grid">
        {stats.map((stat) => (
          <div className="inv-stat-card" key={stat.id}>
            <div className="inv-stat-icon" style={{ backgroundColor: stat.iconBg, color: stat.iconColor }}>
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                {stat.icon}
              </svg>
            </div>
            <div className="inv-stat-info">
              <p className="inv-stat-title">{stat.title}</p>
              <div className="inv-stat-value-row">
                <h3 className="inv-stat-main-val">{stat.value}</h3>
                {stat.badge && <span className={`inv-stat-badge ${stat.badgeColor}`}>{stat.badge}</span>}
              </div>
              <p className="inv-stat-subtext">{stat.subtext}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Tabs */}
      <div className="inv-tabs-container">
        {tabs.map(tab => (
          <button 
            key={tab} 
            className={`inv-tab ${activeTab === tab ? 'active' : ''}`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* Main Table Area */}
      <div className="inv-main-area">
        
        {/* Filters Row */}
        <div className="inv-filters-row">
          <div className="inv-search-box">
            <svg className="search-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path></svg>
            <input type="text" placeholder="Search by product name, SKU or barcode..." />
          </div>
          
          <select className="inv-select"><option>All Categories</option></select>
          <select className="inv-select"><option>All Warehouses</option></select>
          <select className="inv-select"><option>Stock Status</option></select>
          
          <button className="inv-btn-outline">
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"></path></svg>
            More Filters
          </button>

          <button className="inv-btn-primary">
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"></path></svg>
            Export
          </button>
        </div>

        {/* Table */}
        <div className="inv-table-wrapper">
          <table className="inv-table">
            <thead>
              <tr>
                <th className="th-bold">#</th>
                <th className="th-bold">Product</th>
                <th className="th-bold">SKU / Barcode</th>
                <th className="th-bold">Category</th>
                <th className="th-bold">Warehouse</th>
                <th className="th-bold text-center">Current Stock</th>
                <th className="th-bold text-center">Min. Stock</th>
                <th className="th-bold">Stock Value</th>
                <th className="th-bold">Status</th>
                <th className="th-bold">Last Updated</th>
                <th className="th-bold text-center">Actions</th>
              </tr>
            </thead>
            <tbody>
              {tableData.map((row) => (
                <tr key={row.id}>
                  <td className="td-id">{row.id}</td>
                  <td>
                    <div className="inv-product-cell">
                      <div className="inv-product-img">{row.img}</div>
                      <div>
                        <div className="inv-product-name">{row.name}</div>
                        {row.subName && <div className="inv-product-subname">{row.subName}</div>}
                      </div>
                    </div>
                  </td>
                  <td>
                    <div className="inv-sku">{row.sku}</div>
                    <div className="inv-barcode">{row.barcode}</div>
                  </td>
                  <td className="td-text">{row.category}</td>
                  <td className="td-text">{row.warehouse}</td>
                  <td className="text-center">
                    <div className="inv-stock-val">{row.stock}</div>
                    <div className="inv-stock-unit">Units</div>
                  </td>
                  <td className="text-center td-text">{row.minStock}</td>
                  <td className="inv-stock-value">{row.value}</td>
                  <td>
                    <span className={`inv-status-badge ${getStatusClass(row.status)}`}>
                      {row.status}
                    </span>
                  </td>
                  <td>
                    <div className="inv-date">{row.date}</div>
                    <div className="inv-time">{row.time}</div>
                  </td>
                  <td>
                    <div className="inv-actions">
                      <button className="inv-action-btn">
                        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"></path></svg>
                      </button>
                      <button className="inv-action-btn">
                        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"></path></svg>
                      </button>
                      <button className="inv-action-btn">
                        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"></path></svg>
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="inv-pagination-row">
          <div className="inv-pagination-info">
            Showing 1 to 10 of 346 entries
          </div>
          
          <div className="inv-pagination-controls">
            <button className="inv-page-btn">‹</button>
            <button className="inv-page-btn active">1</button>
            <button className="inv-page-btn">2</button>
            <button className="inv-page-btn">3</button>
            <button className="inv-page-btn dot-btn">...</button>
            <button className="inv-page-btn">35</button>
            <button className="inv-page-btn">›</button>
          </div>

          <div className="inv-pagination-limit">
            Show 
            <select className="inv-select-limit">
              <option>10</option>
              <option>20</option>
              <option>50</option>
            </select>
            per page
          </div>
        </div>

      </div>
    </div>
  );
};

export default Inventory;